import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

import Checkbox from '../../shared/Checkbox';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: 8
  }
}));

const DispatchDocumentType = ({ checked, type, active, onClick, onCheck, icon, title, subtitle, tenantColor, disabled }) => {
  const classes = useStyles();

  const getTooltip = () => {
    switch (type) {
      case 'DISPATCH_DOCUMENT':
        return 'Unavailable until one or more sets/items shipped';
      case 'CHECKLISTS':
      case 'UDI_REFERENCE_DOCUMENT':
        return 'Unavailable until sets completed inspection';
      default:
        return '';
    }
  };

  return (
    <div
      className="dispatch-modal__document-type-container"
      onClick={onClick}
      style={active ? { border: `1px solid ${tenantColor}` } : {}}
    >
      <div className="d-flex space-between">
        <div className="d-flex">
          {icon}
          <div className="m-l-md font-bold">{title}</div>
        </div>
        {disabled ? (
          <Tooltip
            title={getTooltip()}
            aria-label='disabled-checkbox'
            classes={{ tooltip: classes.tooltip }}
          >
            <div>
              <Checkbox
                disabled={disabled}
                input={{
                  onChange: (e) => {
                    onCheck(e.target.checked);
                  },
                  checked: checked,
                }}
              />
            </div>
          </Tooltip>
        ) : (
          <Checkbox
            input={{
              onChange: (e) => {
                onCheck(e.target.checked);
              },
              checked: checked,
            }}
          />
        )}
      </div>
      <div className="m-t-md">
        {subtitle}
      </div>
    </div>
  )
};

export default DispatchDocumentType;
